export default {
  appName: 'Management System',
  yes: 'Yes',
  no: 'No',
  search: 'Search',
  reset: 'Reset',
  cancel: 'Cancel',
  confirm: 'Confirm',
  edit: 'Edit',
  delete: 'Delete',
  actions: 'Actions',
  emptyDash: '—',
  adminFallback: 'Admin',
  comingSoon: 'Coming soon'
}
